import type { FC } from "react";

import dompurify from "isomorphic-dompurify";

import { AlertBanner } from "@jti/core-components/components/AlertBanner";
import { useTranslations } from "@jti/ui";

import styles from "./DiscountDisclaimer.module.scss";

const { sanitize } = dompurify;

type DiscountDisclaimerProps = {
  warningMessage?: string | null;
  disclaimerMessage?: string | null;
};

export const DiscountDisclaimer: FC<DiscountDisclaimerProps> = ({ disclaimerMessage, warningMessage }) => {
  const { __ } = useTranslations();

  return !!disclaimerMessage || !!warningMessage ? (
    <div className={styles.container}>
      <AlertBanner
        title={disclaimerMessage ? __("cart.checkout.discount_disclaimer_title") : undefined}
        tone="warning"
        richDescription={
          <>
            {!!disclaimerMessage && (
              <div
                className={styles.item}
                dangerouslySetInnerHTML={{
                  __html: sanitize(disclaimerMessage),
                }}
              />
            )}
            {!!warningMessage && (
              <div
                className={styles.item}
                dangerouslySetInnerHTML={{
                  __html: sanitize(warningMessage),
                }}
              />
            )}
          </>
        }
      />
    </div>
  ) : null;
};
